import * as z from "zod/v4";

/**
 * Schema for parsing dates from database.
 * Handles both ISO date strings and Date objects.
 */
export const DateSchema = z.iso
  .datetime()
  .transform((data) => new Date(data))
  .or(z.date());
